import { BaseRoutingComponent } from './../../../common/base-routing/base-routing.component';
import { QuickstartKeypadsService } from './../services/keypads.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { QuickstartProgrammingService } from '../../services/quickstart-programming.service';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { SharedProgrammingService } from '../../../common/services/shared-programming.service';

@Component({
  selector: 'prg-select-keypad-button',
  templateUrl: './select-keypad-button.component.html',
  styleUrls: ['./select-keypad-button.component.less']
})
export class SelectKeypadButtonComponent extends BaseRoutingComponent implements OnInit {

  private keypadButtons: Observable<Array<any>>;
  private keypad: Observable<any>;
  private ready: Observable<boolean>;

  constructor(
    protected router: Router,
    protected store: Store<any>,
    private shared: SharedProgrammingService,
    private route: ActivatedRoute,
    private buttons: QuickstartKeypadsService
  ) {
    super();
    this.keypadButtons = this.store.select(s => s.keypadProgramming.trigger.buttons);
    this.keypad = this.store.select(s => s.keypadProgramming.trigger.keypad);
    this.ready = this.buttons.ready;
  }

  ngOnInit() {
    // this.shared.setTitle('Select a Keypad Button');
  }

  buttonSelected(button: any) {
    this.buttons.setButton(button);
    this.router.navigate(['../interactions'], { relativeTo: this.route });
  }

  goHome() {
    this.router.navigate(['../programming'], { relativeTo: this.moduleRoot });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-keypads/select-keypad-button/select-keypad-button.component.ts